/**
 * Created by remco on 28/10/15.
 */
 /* global $, window, document */
(function() {
    // Resize title if needed if it was set to $fz-large (50px)
    if($('.pageheader .h1').css('font-size') == '50px'){
        var fontSize = 50;
        var target = $('.pageheader .h1');
        var targetWidth = $('.header_title').width() - 30;
        
        target.css('line-height', target.css('font-size'));
        
        while(target.width() > targetWidth) {
            fontSize -= 1;
            if(fontSize < 22) { break; }
            target.css('font-size', fontSize+'px');
        }
    }
    $('.pageheader .h1').css('visibility', 'visible');
    
    // Hack: Modify faceted navigation spinner.
    // Because we want to use the same CSS based one
    // as used by the search feature. (PCM-2209)
    if($('body').hasClass('template-facetednavigation_view')) {
        $(document).on('DOMNodeInserted', function(e) {
            var newEl = $(e.target);
            if ( newEl.hasClass('faceted_loading') ) {
                newEl.append('<div></div>');
            }
        });
    }

    window.bcastMsgInit();
    
    $('.frontend .easyformForm .myselectpicker').selectpicker();

    $('.input-group.ymdhm').each(function () {
        $(this).datetimepicker(
            {
                format: 'DD-MM-YYYY HH:mm',
                locale: 'nl'
            }
        );

        $(this).on('dp.change', function(e) {
          if (e.date) {
            $(this).find('.datetimepicker_year').val(e.date.format('YYYY'));
            $(this).find('.datetimepicker_month').val(e.date.format('MM'));
            $(this).find('.datetimepicker_day').val(e.date.format('DD'));
            $(this).find('.datetimepicker_hour').val(e.date.format('HH'));
            $(this).find('.datetimepicker_minute').val(e.date.format('mm'));
          }
          else {
            $(this).find('.datetimepicker_year').val('');
            $(this).find('.datetimepicker_month').val('');
            $(this).find('.datetimepicker_day').val('');
            $(this).find('.datetimepicker_hour').val('');
            $(this).find('.datetimepicker_minute').val('');
          }
        });
    });

    // datetimepicker possibilities
    $('.input-group.ymd').each(function () {
        $(this).datetimepicker(
            {
                format: 'DD-MM-YYYY',
                locale: 'nl'
            }
        );

        $(this).on('dp.change', function(e) {
          if (e.date) {
            $(this).find('.datetimepicker_year').val(e.date.format('YYYY'));
            $(this).find('.datetimepicker_month').val(e.date.format('MM'));
            $(this).find('.datetimepicker_day').val(e.date.format('DD'));
            $(this).find('.datetimepicker_hour').val($(this).find('.datetimepicker_hour').attr('originalvalue'));
            $(this).find('.datetimepicker_minute').val($(this).find('.datetimepicker_minute').attr('originalvalue'));
          }
          else {
            $(this).find('.datetimepicker_year').val('');
            $(this).find('.datetimepicker_month').val('');
            $(this).find('.datetimepicker_day').val('');
            $(this).find('.datetimepicker_hour').val('');
            $(this).find('.datetimepicker_minute').val('');
          }
        });
    });

    $('.input-group.hm').each(function () {
        $(this).datetimepicker(
            {
                format: 'HH:mm',
                locale: 'nl'
            }
        );

        $(this).on('dp.change', function(e) {
          if (e.date) {
            $(this).find('.datetimepicker_year').val($(this).find('.datetimepicker_year').attr('originalvalue'));
            $(this).find('.datetimepicker_month').val($(this).find('.datetimepicker_month').attr('originalvalue'));
            $(this).find('.datetimepicker_day').val($(this).find('.datetimepicker_day').attr('originalvalue'));
            $(this).find('.datetimepicker_hour').val(e.date.format('HH'));
            $(this).find('.datetimepicker_minute').val(e.date.format('mm'));
          }
          else {
            $(this).find('.datetimepicker_year').val('');
            $(this).find('.datetimepicker_month').val('');
            $(this).find('.datetimepicker_day').val('');
            $(this).find('.datetimepicker_hour').val('');
            $(this).find('.datetimepicker_minute').val('');
          }
        });
    });

    // init inpage navigation
    // ignore devices smaller than 480px
    if ($(window).width() >= 480) {
        $('#toc').tocify({
            context: '#content-core',
            selectors: 'h2',
            theme: 'none'
        });

        // group all links under one single ul
        $('#toc').append($('<ul class="linklist linklist-dark">'));
        $('#toc .tocify-header li').each(function() {
            $(this).appendTo('#toc .linklist');
        });
        $('#toc .tocify-header').remove();

        // fix extendPage on pages with large last item
        $('#content-core').on('DOMNodeInserted', '.tocify-extend-page', function() {
            var lastElem,
                lastElemOffset;

            lastElem = $('div[data-unique="' + $('.tocify-item').last().attr("data-unique") + '"]');

            if(!lastElem.length) return;

            // Gets the top offset of the page header that is linked to the last toc item
            lastElemOffset = lastElem.offset().top;

            if ($(window).scrollTop() > lastElemOffset) {
                $('.tocify-extend-page').height(0);
            }
        });
    } else {
        // Build toc under H1 (PCM-2174)
        if($('#toc').length) {
            $('<div id="mobile-toc-container"></div>').insertAfter('#content header');
            $('#mobile-toc-container').addClass("bg-tertiary padding-default mbottom-default");
            $('<div id="mobile-toc"></div>').prependTo('#mobile-toc-container');
            $('.inpage-nav-container.xs-hide h2').prependTo('#mobile-toc-container');
            $('#mobile-toc').tocify({
                context: '#content-core',
                selectors: 'h2',
                theme: 'none'
            });
        }
    }

    $('#fieldset-voor-wie span.option').css('display', 'block');

    // Hack for PCM-1872
    // Easyform adds the value of radio buttons after the label between ()'s.
    // It also does this when no | is present and value and label are identical,
    // which is always the case for us.
    var reValue = new RegExp("\\s\\([^)]+\\)$");
    $('.frontend input[type="radio"] + span.label').each(function() {
        var label = $(this);
        var origText = label.text();
        var newText = origText.replace(reValue, '');
        label.text(newText);
    })

    // Hack/workaround for non-working date pickers PCM-1976
    // Sets placeholders for non-working date pickers for anonymous users.
    // Undo when https://github.com/collective/collective.easyform/issues/203 is fixed.
    // Must match expected date formats, of course.
    $('form.easyformForm input.pat-pickadate:visible').each(function(){
        if($.parseJSON($(this).attr('data-pat-pickadate'))["time"]){
            $(this).attr('placeholder', 'YYYY-MM-DD HH:MM');
        } else {
            $(this).attr('placeholder', 'YYYY-MM-DD');
        }
    });
    $('form.easyformForm input.date-field:visible').attr('placeholder', 'd-M-yy');
    $('form.easyformForm input.datetime-field:visible').attr('placeholder', 'd-M-yy H:mm');

    // Snippet from websites js where it is not always triggered.
    $('.slider-mask').each(function () {
        $(this).css('height', $(this).width()*2/3);
    });

    // Workaround/fix for https://jira.ugent.be/browse/PCM-1980
    var fakeAnchor = window.location.hash;
    if(fakeAnchor){
        fakeAnchor = fakeAnchor.substring(1);
        $('li.tocify-item[data-unique="' + fakeAnchor + '"]').trigger('click').trigger('click'); // yes, twice
    }

    // Workaround/fix for https://jira.ugent.be/browse/PCM-2056
    $('#content-core img.image-right').parents('figure').addClass('pull-right');
    $('#content-core img.image-left').parents('figure').addClass('pull-left');

    $('body:not(.frontend) main>.col-xs-12.col-sm-9').each(function(){
        if($('.portal-column-one').size() == 0 && $('.portal-column-two').size() == 0) {
            $(this).removeClass('col-sm-9');    
        }
    })

    // Workaround/hack for https://jira.ugent.be/browse/PCM-2099
    $('body:not(.frontend) #btn-upload').remove();

    // Workaround/hack for https://jira.ugent.be/browse/PCM-2105
    $('#form-widgets-referrer_for_feedback').val() || $('#form-widgets-referrer_for_feedback').val(document.referrer || document.location.href.replace(/\/feedback$/, ''));

    // Workaround/hack for https://jira.ugent.be/browse/PCM-2242
    var other = $('input[name*="wat_voor_vraag_heeft_u"][value="info@ugent.be"]').closest('span');
    other.appendTo(other.parent());

    // Prevent Double Submits on easyforms for PCM-2182
    // See https://www.bram.us/2020/11/04/preventing-double-form-submissions/
    document.querySelectorAll('#content-core form.easyformForm').forEach(function(form) {
        form.addEventListener('submit', function(e) {
            // Prevent if already submitting
            if (form.classList.contains('is-submitting')) {
                e.preventDefault();
            }
            
            // Add class to hook our visual indicator on
            form.classList.add('is-submitting');
        });
    });

    // Start making collections checkbox a shadow option for
    // the documents checkbox.
    var collectionCheckbox = $('#searchResultsFilter .search-type-options [value="Collection"]');
    if(collectionCheckbox.length) {
        var documentCheckbox   = $('#searchResultsFilter .search-type-options [value="Document"]');

        collectionCheckbox.parent().hide();
        documentCheckbox.on('click', function(){
            collectionCheckbox.prop('checked', documentCheckbox.prop('checked'));
        })
        if(collectionCheckbox.prop('checked') != documentCheckbox.prop('checked')) {
            collectionCheckbox.trigger('click');
        }
    }
  // End shadow option
}());

// eslint-disable-next-line no-unused-vars
var topFunction = function() {
    document.body.scrollTop = 0;            // For Safari
    document.documentElement.scrollTop = 0; // For others
}
